module.exports = __webpack_public_path__ + "img/LDSJ_STILL24.4fc15494.jpg";